import { render, staticRenderFns } from "./TastingPhotoUploadFormModal.vue?vue&type=template&id=3b8d77b6&scoped=true"
import script from "./TastingPhotoUploadFormModal.vue?vue&type=script&lang=js"
export * from "./TastingPhotoUploadFormModal.vue?vue&type=script&lang=js"
import style0 from "./TastingPhotoUploadFormModal.vue?vue&type=style&index=0&id=3b8d77b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d77b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8d77b6')) {
      api.createRecord('3b8d77b6', component.options)
    } else {
      api.reload('3b8d77b6', component.options)
    }
    module.hot.accept("./TastingPhotoUploadFormModal.vue?vue&type=template&id=3b8d77b6&scoped=true", function () {
      api.rerender('3b8d77b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasting-photos/TastingPhotoUploadFormModal.vue"
export default component.exports